// extracted by mini-css-extract-plugin
export var mainCenter = "Main-module--mainCenter--3Fc7m";
export var mainImg = "Main-module--mainImg--3UCt1";
export var view = "Main-module--view--1SLe6";
export var storeLinks = "Main-module--storeLinks--16shH";
export var storePosition = "Main-module--storePosition--3qIJm";